<div class="container" role="main">
    <div class="HmsContainer">
        <div class="row">
            <div class="row HmsInsideContainer">
                <div class="col-md-12">
                    <button type="button" class="greyBtn" (click)="back()" style="font-weight : bold;">Go to Previous
                        Section</button>
                    <button type="button" class="greyBtn ml-5" *ngIf="isInstruction" (click)="openInstruction()"
                        style="font-weight : bold;">Instructions</button>
                    <button type="button" class="orangeBtn ml-5" *ngIf="isFormsValid" (click)="referalFormSubmit()"
                        [ngStyle]="{'background-color': primaryColor}">Proceed
                        to Next Section</button>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-md-12">
                    <p role="heading" aria-level="1">Witness or Referring Party Information</p>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="referalForm" [formGroup]="referalForm">
                        <div class="col-md-10">
                            <app-json-form [controlsData]="referalFormData.controls" [formData]="referalForm"
                                (valueChangeEvent)="valueChange($event)"></app-json-form>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row HmsInsideContainer" *ngIf="isExternalReferringParty == 'Yes'">
                <div class="col-md-12">
                    <p role="heading" aria-level="1">Please enter any information you have regarding the witness or
                        referring party</p>
                </div>
            </div>
            <div class="row HmsInsideContainer" *ngIf="isformloaded">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="referalForm" [formGroup]="referalFormPart1">
                        <div class="col-md-10" *ngIf="isExternalReferringParty == 'Yes'">
                            <app-json-form [controlsData]="referalFormDataPart1.subcontrols"
                                [formData]="referalFormPart1" (valueChangeEvent)="valueChange($event)"></app-json-form>
                        </div>
                    </form>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="referalForm" [formGroup]="referalFormPart2">
                        <div class="col-md-10" *ngIf="isExternalReferringParty == 'Yes'">
                            <app-json-form [controlsData]="referalFormDataPart2.subcontrols"
                                [formData]="referalFormPart2" (valueChangeEvent)="valueChange($event)"></app-json-form>
                        </div>
                    </form>
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <form class="referalForm" [formGroup]="referalFormPart3">
                                <div class="col-md-10" *ngIf="isExternalReferringParty == 'Yes'"
                                    style="width: 85% !important;">
                                    <app-json-form [controlsData]="referalFormDataPart3.subcontrols"
                                        [formData]="referalFormPart3"
                                        (valueChangeEvent)="valueChange($event)"></app-json-form>
                                </div>
                            </form>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <form class="referalForm" [formGroup]="referalFormPart4">
                                <div class="col-md-10" *ngIf="isExternalReferringParty == 'Yes'"
                                    style="width: 65% !important;">
                                    <app-json-form [controlsData]="referalFormDataPart4.subcontrols"
                                        [formData]="referalFormPart4"
                                        (valueChangeEvent)="valueChange($event)"></app-json-form>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>